import React, { useState } from 'react'

import { ICON } from 'config/icons'

import { TWithInnerButtonInputProps, WithInnerButtonInput } from './WithInnerButtonInput'

export type TPasswordInputProps = TOptionalValues<TWithInnerButtonInputProps, 'buttonIcon' | 'onButtonClick'>

/**
 * ### PasswordInput ###
 *
 * /!\ Warning: if you alter the input padding, using p prop, you must adjust inputPaddingRight:
 * otherwise, when the input is full of text, it won't be clean.
 */
export const PasswordInput = React.forwardRef<HTMLInputElement, TPasswordInputProps>((props, ref) => {
  const [visiblePassword, setVisiblePassword] = useState(false)

  const togglePasswordVisibility = () => {
    setVisiblePassword(!visiblePassword)
  }

  return (
    <WithInnerButtonInput
      buttonIcon={ICON.EYE}
      buttonLabel="trans:common:password.show"
      isButtonActive={visiblePassword}
      onButtonClick={togglePasswordVisibility}
      type={visiblePassword ? 'text' : 'password'}
      ref={ref}
      {...props}
    />
  )
})

PasswordInput.displayName = 'PasswordInput'
